import { ApiFragment, Mh2Entity } from '@stylehaven/components';

export const GetCombinedEntityFromFragments = (fragments: readonly ApiFragment[]): Mh2Entity => {
    const allEntities: Mh2Entity[] = fragments.map(fragment => fragment.getMh2Entity());
    const combinedEntity: Mh2Entity = getCombinedEntity(allEntities);

    return combinedEntity ?? Mh2Entity.Generic;
};

const getCombinedEntity = (entities: readonly Mh2Entity[]) => {
    return entities.reduce((previousValue: Mh2Entity, currentValue: Mh2Entity) => {
        if (previousValue === currentValue) {
            return currentValue;
        }
        return Mh2Entity.Generic;
    }, entities[0]);
};
